module.exports = __webpack_public_path__ + "img/1.9ea21409.png";